module.exports = __webpack_public_path__ + "img/register-v2.4cf3347e.png";